import { useSelector } from 'react-redux'
import {
  BUY_DOWN_TYPE,
  NO_CLEAR_BUY_DOWN_TYPE_FOUND,
  ONE_ONE,
  ONE_ZERO,
  THREE_TWO_ONE,
  TWO_ONE
} from '../EstimatedMonthlyPaymentBreakdown/EstimatedMonthlyPaymentBreakdownBuyDownToggle/BuyDownType'
import {
  HIGH_LTV_PMI_RATES,
  MEDIUM_HIGH_LTV_PMI_RATES,
  MEDIUM_LOW_LTV_PMI_RATES,
  LOW_LTV_PMI_RATES,
  PMI_CREDIT_BANDS,
  PMI_THRESHOLD,
  RATES_OFFSETS,
  DEFAULT_LOAN_TERM,
  DEFAULT_CREDIT_SCORE
} from './EstimatedMonthlyPaymentConstants'

export const calculateMonthlyPMI = (loanAmount: number, homePrice: number, creditScore: number): number => {
  const LTV = loanAmount / homePrice

  if (LTV < PMI_THRESHOLD) {
    return 0
  }

  let rateArray = new Array(PMI_CREDIT_BANDS.length).fill(0)

  if (LTV >= 0.95) {
    rateArray = HIGH_LTV_PMI_RATES
  } else if (LTV > 0.9) {
    rateArray = MEDIUM_HIGH_LTV_PMI_RATES
  } else if (LTV > 0.85) {
    rateArray = MEDIUM_LOW_LTV_PMI_RATES
  } else if (LTV > 0.8) {
    rateArray = LOW_LTV_PMI_RATES
  }

  for (let i = 1; i < PMI_CREDIT_BANDS.length; i++) {
    if (creditScore < PMI_CREDIT_BANDS[i]) {
      const PMIRate = rateArray[i - 1]
      return (loanAmount * PMIRate) / 12
    }
  }

  const PMIRate = rateArray[rateArray.length - 1]
  return (loanAmount * PMIRate) / 12
}

export const calculateMonthlyPayment = (loanAmount: number, annualRate: number, loanTermYears: number) => {
  const r = annualRate / 100 / 12
  const n = loanTermYears * 12
  const numerator = r * Math.pow(1 + r, n)
  const denominator = Math.pow(1 + r, n) - 1
  const monthly = loanAmount * (numerator / denominator)

  return monthly
}

export const getRate = (currentRate: number, creditScore: number) => {
  let rateOffset: number

  if (creditScore >= 800) {
    rateOffset = RATES_OFFSETS['800']
  } else if (creditScore >= 740) {
    rateOffset = RATES_OFFSETS['740']
  } else if (creditScore >= 720) {
    rateOffset = RATES_OFFSETS['720']
  } else if (creditScore >= 700) {
    rateOffset = RATES_OFFSETS['700']
  } else if (creditScore >= 680) {
    rateOffset = RATES_OFFSETS['680']
  } else if (creditScore >= 660) {
    rateOffset = RATES_OFFSETS['660']
  } else if (creditScore >= 640) {
    rateOffset = RATES_OFFSETS['640']
  } else {
    rateOffset = RATES_OFFSETS['620']
  }

  return currentRate + rateOffset
}

export const getCalculatedBuyDownType = (
  concessionAmount: number,
  loanAmount: number,
  listingBuyDownType: BUY_DOWN_TYPE
) => {
  if (listingBuyDownType !== NO_CLEAR_BUY_DOWN_TYPE_FOUND) {
    return listingBuyDownType
  }

  // Caculations are basic - used to get default buy down type, not meant to be a quote
  const costOfThreeTwoOne = loanAmount * 0.03 + loanAmount * 0.02 + loanAmount * 0.01
  const costOfTwoOne = loanAmount * 0.02 + loanAmount * 0.01
  const costOfOneOne = loanAmount * 0.01 + loanAmount * 0.01
  const costOfOneZero = loanAmount * 0.01

  if (concessionAmount >= costOfThreeTwoOne) {
    return THREE_TWO_ONE
  } else if (concessionAmount >= costOfTwoOne) {
    return TWO_ONE
  } else if (concessionAmount >= costOfOneOne) {
    return ONE_ONE
  } else if (concessionAmount >= costOfOneZero) {
    return ONE_ZERO
  } else {
    // default if concession amount can't cover any buy down type
    return NO_CLEAR_BUY_DOWN_TYPE_FOUND
  }
}
